export default __webpack_public_path__ + "static/media/no-photo.0db95791.png";